export default function openDialogWindow(url) {
  window.open(
    url,
    'open_window',
    'menubar=no, toolbar=no, location=no, directories=no, status=no, scrollbars=no, resizable=no, dependent, width=1360, height=648, left=0, top=0',
  );
}
